import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import ComplexProjectCard from "cxfcomponents/Cards/ProjectCards/ComplexProjectCard";
import DefaultAdminIcon from "assets/images/DefaultAdminIcon.svg";
import DefaultUserIcon from "assets/images/DefaultUserIcon.svg";
import SoftTypography from "components/SoftTypography";

function TileView({ data }) {
  const getRoleIcon = (roleName) => {
    const nameLower = roleName?.toLowerCase();
    if (nameLower === "admin") {
      return DefaultAdminIcon;
    }
    return DefaultUserIcon;
  };

  if (!data || data.length === 0) {
    return (
      <SoftTypography variant="body2" color="textSecondary" textAlign="center" p={3}>
        No roles to display.
      </SoftTypography>
    );
  }

  return (
    <SoftBox
      className="role-tiles-grid"
      display="grid"
      sx={{
        gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
        gap: 1,
        justifyContent: "start",
        alignItems: "stretch",
        marginBottom: "16px",
      }}
      data-testid="tiles"
    >
      {data?.map((row) => {
        const role = row?.original;
        if (!role) return null;

        return (
          <SoftBox
            key={role.id || role.name}
            sx={{
              gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
              gap: 2,
              justifyContent: "start",
              alignItems: "stretch",
            }}
          >
            <ComplexProjectCard
              title={role?.name}
              role_id={role?.id}
              description={role?.description || ""}
              icon={getRoleIcon(role?.name)}
              members={role?.users || []}
              dateTime={role?.dateTime || ""}
              status={role?.status || null}
              color={role?.color || "light"}
              dropdown={role?.dropdown || false}
            />
          </SoftBox>
        );
      })}
    </SoftBox>
  );
}

TileView.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  groupBy: PropTypes.array,
  handleOpenRoleForm: PropTypes.func, 
};

export default TileView;
